// The legacy copy promises a 404 on direct shop access. The new storefront
// serves the shop with noindex instead, so it needs its own copy.
export const LEGACY_REDIRECT_DESCRIPTION_KEY =
  'SA.integration.redirectUrl.description';
export const NEW_STOREFRONT_REDIRECT_DESCRIPTION_KEY =
  'SA.integration.redirectUrl.descriptionNewStorefront';

export function redirectDescriptionKey(newStorefront: boolean): string {
  return newStorefront
    ? NEW_STOREFRONT_REDIRECT_DESCRIPTION_KEY
    : LEGACY_REDIRECT_DESCRIPTION_KEY;
}
